import { T_LANDING_PAGE_CONSTANTS } from './TYPES'

const EN_LANDING_PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS = {
  PAGE_KICKER: 'Book. Quiz. Community.',
  PAGE_TITLE: 'A quiz library where reading and play come together.',
  PAGE_DESCRIPTION:
    'Children read books offline, then complete short quizzes that check their reading comprehension. Along the way, they earn points, grow Griffy, their griffin, and can join reading challenges as well.',
  GET_STARTED_CTA_TEXT: 'Create Free Account',
  CARD_1_TITLE: 'Read a Book',
  CARD_1_DESCRIPTION: 'Read a book—no screen required.',
  CARD_2_TITLE: 'Take the Quiz',
  CARD_2_DESCRIPTION:
    'Build strong reading comprehension and join a community of readers.',
  CARD_3_TITLE: 'Earn Rewards',
  CARD_3_DESCRIPTION: 'Earn points and badges, and help Griffy grow.',
  FEATURES_KICKER: 'WHAT IS GRIFFYREADS? TELL ME MORE',
  FEATURES_TITLE: 'About its Features',
  FEATURES_CHILD_LABEL: 'FOR CHILDREN',
  FEATURES_ADULT_LABEL: 'FOR ADULTS',
  FEATURES_ENHANCE_READING_TITLE: [
    { label: 'Start Your' },
    {
      label: 'Reading',
      color: true,
      newLine: true
    },
    { label: 'Journey' }
  ],
  FEATURES_ENHANCE_READING_DESCRIPTION:
    'Read books offline and take on exciting challenges across various genres! Daily reading boosts your vocabulary and communication skills, increases your creativity and enhances your empathy, while making learning fun and rewarding.',
  FEATURES_UNLOCK_AVATARS_TITLE: [
    { label: 'Answer Quizzes, Earn Points &' },
    {
      label: 'Develop your Griffy',
      color: true
    }
  ],
  FEATURES_UNLOCK_AVATARS_DESCRIPTION:
    'Test your knowledge with fun quizzes and earn points for each correct answer! Level up and observe your Griffy getting stronger as you embark on new adventures.',
  FEATURES_CHALLENGE_FRIENDS_TITLE: [
    {
      label: 'Challenge',
      color: true
    },
    {
      label: 'Friends'
    }
  ],
  FEATURES_CHALLENGE_FRIENDS_DESCRIPTION:
    'Take on reading challenges and see who can earn the most points. May the best reader win!',
  FEATURES_EARN_BADGES_TITLE: [
    { label: 'Earn' },
    {
      label: 'Badges',
      color: true
    }
  ],
  FEATURES_EARN_BADGES_DESCRIPTION:
    'Earn various badges for your accomplishments and progress!',
  FEATURES_CREATE_COMPETITIONS_TITLE: [
    { label: 'Create Engaging' },
    {
      label: 'Reading',
      color: true,
      newLine: true
    },
    { label: 'Challenges' }
  ],
  FEATURES_CREATE_COMPETITIONS_DESCRIPTION:
    'Encourage reading by creating exciting competitions for your children or community. Motivate young readers to participate in fun, educational challenges!',
  FEATURES_MANAGE_AND_TRACK_TITLE: [
    { label: 'Effortlessly' },
    {
      label: 'Manage',
      color: true
    },
    { label: 'and' },
    {
      label: 'Track',
      color: true
    },
    {
      label: 'Children Reading'
    }
  ],
  FEATURES_MANAGE_AND_TRACK_DESCRIPTION:
    "Managing their reading, and organizing contests is a breeze. Effortlessly monitor each child's progress, achievements, and challenges!",
  FEATURES_CONTRIBUTE_TITLE: [
    { label: 'Upload Quizzes and' },
    {
      label: 'Grow',
      color: true,
      newLine: true
    },
    { label: 'the Platform' }
  ],
  FEATURES_CONTRIBUTE_DESCRIPTION:
    'Upload your own quizzes to help expand our library of educational content. Your contributions directly enhance the learning experience for young readers!',

  HIGHLIGHT_TITLE: 'Safe and made for kids',
  HIGHLIGHT_DESCRIPTION:
    'A kid-friendly space where learning meets fun. Parents can relax knowing their kids are in a safe environment.',
  DOWNLOAD_TITLE: 'What are you waiting for?',
  DOWNLOAD_DESCRIPTION:
    'The magical world of GriffyReads is just a click away. Sign up now and start your exciting reading journey. Develop your Griffy, earn points, and become a reading champion!'
}

export default EN_LANDING_PAGE_CONSTANTS
